const toggle = document.querySelector(".toggle"),
  nav = document.querySelector(".header__nav");

toggle.addEventListener("click", () => {
  nav.classList.toggle("isOpen");
});
